var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ModalContent', {
    attrs: {
      "flat-chrome": ""
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("Inviter le client à compléter sa fiche")]), _c('template', {
    slot: "content"
  }, [_vm.loading && !_vm.preview ? _c('div', {
    staticClass: "py-8 text-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary",
      "aria-label": "Chargement des destinataires"
    }
  })], 1) : _vm._e(), _vm.error ? _c('v-alert', {
    staticClass: "profile-error",
    attrs: {
      "type": "error",
      "text": "",
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm.preview ? _c('div', {
    staticClass: "stitch-modal general-settings-reference stitch-form"
  }, [_c('v-card', {
    staticClass: "stitch-modal__card profile-request-intro",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('div', {
    staticClass: "d-flex align-start"
  }, [_c('v-avatar', {
    staticClass: "primary mr-4 flex-shrink-0",
    attrs: {
      "size": "44"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("mdi-account-check-outline")])], 1), _c('div', [_c('h3', {
    staticClass: "profile-request-intro__title"
  }, [_vm._v("Une fiche fiable, en quelques minutes")]), _c('p', {
    staticClass: "profile-request-intro__description"
  }, [_vm._v("Un email sécurisé invite votre client à vérifier ses coordonnées, sa facturation et ses lieux de livraison. S’il utilise déjà Safetee, il les confirme dans son espace.")])])], 1)])], 1), !_vm.preview.limits.is_premium && _vm.preview.limits.remaining === 0 ? _c('v-alert', {
    staticClass: "mb-5",
    attrs: {
      "type": "warning",
      "text": ""
    }
  }, [_c('b', {
    staticClass: "d-block"
  }, [_vm._v("Limite quotidienne atteinte")]), _vm._v(" Vous avez utilisé les 2 invitations disponibles aujourd’hui. Vous pourrez inviter de nouveau vos clients " + _vm._s(_vm.quotaReset) + ". L’offre premium permet des invitations sans cette limite. ")]) : _vm._e(), _vm.bulk && !_vm.preview.limits.bulk_allowed ? _c('v-alert', {
    attrs: {
      "type": "info",
      "text": ""
    }
  }, [_vm._v(" L’envoi en masse est réservé à l’offre premium. Demandez une mise à jour à un client à la fois ou passez à l’offre premium. ")]) : _vm._e(), _c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-email-outline")]), _c('span', [_vm._v(_vm._s(_vm.bulk ? 'Destinataires' : 'Destinataire'))])], 1), !_vm.preview.limits.is_premium ? _c('div', {
    staticClass: "mb-3"
  }, [!_vm.preview.limits.is_premium ? _c('span', {
    staticClass: "text-caption grey--text text--darken-1"
  }, [_vm._v(_vm._s(_vm.preview.limits.remaining) + " / 2 demandes disponibles aujourd’hui")]) : _vm._e()]) : _vm._e(), _vm._l(_vm.clients, function (client) {
    return _c('div', {
      key: client.customer_id,
      staticClass: "profile-recipient"
    }, [_c('div', {
      staticClass: "d-flex align-center mb-4"
    }, [_c('v-icon', {
      staticClass: "mr-2",
      attrs: {
        "small": "",
        "color": "primary"
      }
    }, [_vm._v("mdi-domain")]), _c('h4', {
      staticClass: "text-subtitle-1 font-weight-bold"
    }, [_vm._v(_vm._s(client.customer_name))])], 1), _c('label', {
      staticClass: "settings-field-label",
      attrs: {
        "for": "recipient-".concat(client.customer_id)
      }
    }, [_vm._v("Email du destinataire"), _c('StitchHint', {
      attrs: {
        "hint": "Contact principal prérempli. Vous pouvez choisir une autre adresse."
      }
    })], 1), _c('v-text-field', {
      attrs: {
        "id": "recipient-".concat(client.customer_id),
        "placeholder": "Email du destinataire",
        "type": "email",
        "outlined": "",
        "dense": "",
        "hide-details": "auto",
        "disabled": _vm.saving
      },
      on: {
        "input": _vm.changed
      },
      model: {
        value: client.recipient_email,
        callback: function callback($$v) {
          _vm.$set(client, "recipient_email", $$v);
        },
        expression: "client.recipient_email"
      }
    }), _vm.reason(client) ? _c('v-alert', {
      staticClass: "mt-3 mb-0",
      attrs: {
        "dense": "",
        "text": "",
        "type": "warning"
      }
    }, [_vm._v(_vm._s(_vm.reason(client)))]) : _vm._e()], 1);
  })], 2)], 1), _c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-message-text-outline")]), _c('span', [_vm._v("Votre demande")])], 1), _c('label', {
    staticClass: "settings-field-label",
    attrs: {
      "for": "profile-request-message"
    }
  }, [_vm._v("Votre message (facultatif)")]), _c('v-textarea', {
    attrs: {
      "id": "profile-request-message",
      "outlined": "",
      "rows": "3",
      "placeholder": "Ajoutez un mot pour accompagner votre demande…",
      "counter": "2000",
      "maxlength": "2000",
      "disabled": _vm.saving
    },
    on: {
      "input": _vm.changed
    },
    model: {
      value: _vm.message,
      callback: function callback($$v) {
        _vm.message = $$v;
      },
      expression: "message"
    }
  }), _c('p', {
    staticClass: "text-body-2 mb-4"
  }, [_vm._v("Après confirmation, votre client pourra créer un compte Safetee. S’il accepte, il sera connecté automatiquement et relié à votre organisation. Vous serez informé lorsqu’il vous rejoint.")])], 1)], 1), _c('div', {
    staticClass: "profile-request-details"
  }, [_c('div', {
    staticClass: "profile-request-detail"
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "primary"
    }
  }, [_vm._v("mdi-shield-check-outline")]), _c('div', [_c('b', {
    staticClass: "profile-request-detail__title"
  }, [_vm._v("Lien sécurisé")]), _c('div', {
    staticClass: "profile-request-detail__description"
  }, [_vm._v("Valable pendant 14 jours")])])], 1), _c('div', {
    staticClass: "profile-request-detail"
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "primary"
    }
  }, [_vm._v("mdi-email-sync-outline")]), _c('div', [_c('b', {
    staticClass: "profile-request-detail__title"
  }, [_vm._v("Relances incluses")]), _c('div', {
    staticClass: "profile-request-detail__description"
  }, [_vm._v("Après 3 et 10 jours")])])], 1), _c('div', {
    staticClass: "profile-request-detail"
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "primary"
    }
  }, [_vm._v("mdi-check-circle-outline")]), _c('div', [_c('b', {
    staticClass: "profile-request-detail__title"
  }, [_vm._v("Confirmation suivie")]), _c('div', {
    staticClass: "profile-request-detail__description"
  }, [_vm._v("Fiche mise à jour immédiatement, vous êtes informé")])])], 1)])], 1) : _vm._e()], 1), _c('template', {
    slot: "bottom"
  }, [_c('div', {
    staticClass: "profile-modal-actions"
  }, [_c('Button', {
    attrs: {
      "ghost": "",
      "text": "Fermer",
      "disabled": _vm.saving
    },
    on: {
      "click": function click($event) {
        return _vm.hideModal();
      }
    }
  }), !_vm.preview ? _c('Button', {
    attrs: {
      "text": "Réessayer",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.load
    }
  }) : _c('Button', {
    attrs: {
      "text": _vm.bulk ? 'Envoyer les demandes' : 'Envoyer la demande',
      "disabled": !_vm.canSubmit,
      "loading": _vm.saving
    },
    on: {
      "click": _vm.send
    }
  })], 1)])], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }